<div class="flex items-center justify-between mt-4">
  <div class="min-h-[18px] w-[224px] rounded-[5px] bg-[#D9D9D9]/30"></div>
  <div class="flex items-center gap-3">
    <span class="block rounded-[5px] bg-[#D9D9D9]/30 min-h-[28px] w-[28px]"></span>
    <span class="block rounded-[5px] bg-[#D9D9D9]/30 min-h-[28px] w-[28px]"></span>
    <span class="block rounded-[5px] bg-[#D9D9D9]/30 min-h-[28px] w-[28px]"></span>
    <span class="block rounded-[5px] bg-[#D9D9D9]/30 min-h-[28px] w-[28px]"></span>
    <span class="block rounded-[5px] bg-[#D9D9D9]/30 min-h-[28px] w-[28px]"></span>
    <span class="block rounded-[5px] bg-[#D9D9D9]/30 min-h-[28px] w-[28px]"></span>
  </div>
</div>
